import apiClient from '../config'

import type { PurchasedPackage } from '../types'

export interface PackageMappingsResponse {
  environment: 'production' | 'development'
  dev: Record<string, PurchasedPackage>
  prod: Record<string, PurchasedPackage>
  questToBioReference: Record<string, string>
}

export const packageMappingsService = {
  /**
   * Get all package mappings (dev, prod, Quest to BioReference)
   * Directly returns data from purchased-packages.ts without duplication
   */
  async getPackageMappings(): Promise<PackageMappingsResponse> {
    const response = await apiClient.get<PackageMappingsResponse>('/admin/package-mappings')
    return response.data
  },
}

